import React, { useState } from 'react';
import { useMount } from '@shared/utils/hooks/useMount';

import { useCreateBabyRegistryTelemetry } from '@apps/createBabyRegistry/CreateBabyRegistry.telemetry';
import { SupportedView, viewMap, ViewProvider } from '@apps/createBabyRegistry/components/View/ViewProvider';

type ViewProps = Readonly<{
  defaultView?: SupportedView;
}>;

/**
 * It is just an abstraction over react-router, and in my opinion we should get rid of it,
 */
export const View: React.FC<ViewProps> = ({ defaultView = 'createAccount' }) => {
  const [currentView, setCurrentView] = useState<SupportedView>(defaultView);
  const telemetry = useCreateBabyRegistryTelemetry();

  useMount(() => {
    telemetry[currentView]?.enter();
  });

  const changeView = (view: SupportedView) => {
    telemetry[view]?.enter();
    setCurrentView(view);
  };

  const Component = viewMap[currentView];

  return (
    <ViewProvider value={{ changeView, currentView }}>
      <Component />
    </ViewProvider>
  );
};
